import { v4 as uuidv4 } from "uuid";
import { QuestionType } from "api/landlord-surveys/types/questions";
import { DraftDetailedLandlordSurvey } from "./types";

export enum View {
  Questions = "questions",
  Conditions = "conditions"
}

// used as baseline for creating new templates
export const blankTemplate: DraftDetailedLandlordSurvey = {
  name: "",
  is_default: true,
  active: true,
  questions: [
    {
      internal_id: uuidv4(),
      index: 0,
      question: "",
      description: "",
      is_required: false,
      type: QuestionType.LONG_TEXT
    }
  ]
};
